import { DATEPICKER_ROLE } from '@wix/wix-data-client-common-standalone'

import { type DatePickerData } from '../types'
import {
  assertDatePickerData,
  assertNonNullable,
  setConnectionConfigPropertyField,
} from '../utils'
import { addComponentForField } from './addComponentForField'
import { type FieldComponentAdder } from './types'

export const createDatePickerAdder =
  (templateVeloId: string): FieldComponentAdder =>
  ({
    fieldKey,
    fieldName,
    page,
    templateComponentByVeloId,
    templateControllerConnectionsByVeloId,
  }) =>
    addComponentForField({
      page,
      templateComponentByVeloId,
      templateControllerConnectionsByVeloId,
      templateVeloId,
      componentAdjustments: {
        modifyComponent: component => {
          assertNonNullable(component.data)
          assertDatePickerData(component.data)
          const data: DatePickerData = { ...component.data, label: fieldName }
          return { ...component, data }
        },
        connectionConfigModifierByRole: {
          [DATEPICKER_ROLE]: config =>
            setConnectionConfigPropertyField({
              config,
              propertyName: 'value',
              fieldKey,
            }),
        },
        veloId: `${fieldKey}Field`,
      },
    })
